import IndividualRepetitionInterval from '@/domain/termine/features/CreateTermin/Sheet/components/IndividualRepetitionInterval';
import IndividualRepetitionIntervalDrawer from '@/domain/termine/features/CreateTermin/Drawer/components/IndividualRepetitionIntervalDrawer';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { TerminWiederholungsIntervall } from '@/domain/termine/shared/types';
import { Field } from '@e2n/ui';

export function RepeatIntervalSelectFormField({
  className,
}: {
  className?: string;
}) {
  const { form } = useCreateTermineFormContext();

  const validIntervals = new Set<string>(
    Object.values(TerminWiederholungsIntervall),
  );

  function isInterval(value: unknown): value is TerminWiederholungsIntervall {
    return typeof value === 'string' && validIntervals.has(value);
  }

  return (
    <div className={`flex flex-col gap-4 w-2/3 ${className}`}>
      <form.Field name="wiederholungsIntervall">
        {(field) => {
          const intervalValue = isInterval(field.state.value)
            ? field.state.value
            : TerminWiederholungsIntervall.TAG;

          return (
            <Field className="flex flex-col w-full gap-1">
              <div className="block md:hidden">
                <IndividualRepetitionIntervalDrawer
                  value={intervalValue}
                  onChange={field.handleChange}
                />
              </div>
              <div className="hidden md:block">
                <IndividualRepetitionInterval
                  value={intervalValue}
                  onChange={field.handleChange}
                />
              </div>
            </Field>
          );
        }}
      </form.Field>
    </div>
  );
}
